import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { GOODS_RECEIPT, GoodsReceiptStatusValues, GOODS_RECEIPT_STATUS_LABELS, } from '../types/goods-receipt.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for GoodsReceipt header (request 0109).
 * Path: org/{orgId}/goods-receipt — PostgresRest (cross-query with PO / ledger).
 */
export const goodsReceiptDescriptor = {
    name: GOODS_RECEIPT,
    label: 'Recebimento de mercadoria',
    domain: 'purchasing',
    collectionPath: 'org/{orgId}/goods-receipt',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Goods receipt header — inbound stock document for a purchase order',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'receiptNumber',
            example: '4410',
            label: 'Número do recebimento',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.CODE,
        },
        { name: 'purchaseOrderId', label: 'Ordem de compra', type: 'string', required: true },
        { name: 'supplierId', label: 'Fornecedor', type: 'string', required: true },
        { name: 'stockLocationId', label: 'Local de estoque', type: 'string', required: true },
        { name: 'receiptDate', example: '2026-10-10', label: 'Data do recebimento', type: 'date', required: true },
        {
            name: 'status',
            example: 'posted',
            label: 'Status',
            type: 'enum',
            required: true,
            enumValues: [...GoodsReceiptStatusValues],
            enumLabels: GOODS_RECEIPT_STATUS_LABELS,
            defaultValue: 'draft',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'purchaseOrderId',
            targetEntity: 'PurchaseOrder',
            relationship: 'many-to-one',
            displayField: 'code',
        },
        {
            fieldName: 'supplierId',
            targetEntity: 'Party',
            relationship: 'many-to-one',
            displayField: 'displayName',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=goods-receipt.descriptor.js.map